import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import { getAllRestrictedBandsCopy } from "@/assignments/utils/assignmentUtils";
import LoadingShimmerMapper from "@/components/LoadingShimmerMapper/LoadingShimmerMapper";
import { bodyCss } from "./ContentAdvisoryConsentMessage.style";

const propTypes = {
  body: PropTypes.string.isRequired,
  conSetVisibilityMarkers: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool.isRequired,
  hyperlink: PropTypes.object,
};

const ContentAdvisoryConsentMessage = ({
  body,
  conSetVisibilityMarkers,
  loading,
  hyperlink,
}) => {
  const restrictedBandsCopy = getAllRestrictedBandsCopy(
    conSetVisibilityMarkers || [],
  );
  return (
    <div css={bodyCss}>
      <LoadingShimmerMapper loading={loading}>
        <p css={bodyCss}>{body}</p>
        {hyperlink ? (
          <Anchor href={hyperlink.url}>{hyperlink.text}</Anchor>
        ) : null}
      </LoadingShimmerMapper>
      {restrictedBandsCopy ? <p css={bodyCss}>{restrictedBandsCopy}</p> : null}
    </div>
  );
};

ContentAdvisoryConsentMessage.propTypes = propTypes;

export { ContentAdvisoryConsentMessage };
